import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  is_loaded_push_notification: false,
  push_notification: false,
  smtp_details: {},
  api_keys: {},
  is_autoresponder_loaded: false,
  autoresponder: {},
  subdomain_details : {},
  subdomain_list : {},
  all_access_details: {}
};

const settingSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setPusNotification(state, action) {
      state.push_notification = action.payload.push_notification;
      state.is_loaded_push_notification =
        action.payload?.is_loaded_push_notification;
    },
    setSMTPDetails(state, action) {
      state.smtp_details = action.payload.smtp_details;
    },
    setAPIkeys(state, action) {
      state.api_keys = action.payload.api_keys;
    },
    setAutoresponder(state, action) {
      state.autoresponder = action.payload.autoresponder;
      state.is_autoresponder_loaded = true;
    },
    setAutoresponderStatus(state, action) {
      state.is_autoresponder_loaded = action.payload.status;
    },
    setSubdomainDetails(state, action) {
      state.subdomain_details = action.payload.subdomain_details;
    },
    setSubdomain_list(state, action) {
      state.subdomain_list = action.payload.subdomain_list;
    },
    setAccessDetails(state, action) {
      state.all_access_details = action.payload.all_access_details;
    },
  },
});

export const settingAction = settingSlice.actions;
export default settingSlice.reducer;
